export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const openEmailClient = (email: string): void => {
  window.location.href = `mailto:${email}?subject=Rappel concernant votre dossier&body=Bonjour,\n\nNous vous rappelons concernant votre dossier en cours.\n\nCordialement,\nL'équipe S-Collect`;
};

export const openWhatsApp = (telephone: string, nom: string, prenom: string, type: 'voyage' | 'transfert', reference: string, motif: string): void => {
  const phoneNumber = telephone.replace(/[\s\-()]/g, '');
  
  let typeMessage = '';
  if (type === 'voyage') {
    typeMessage = `vos documents de voyage avec référence : "${reference}"`;
  } else {
    typeMessage = `vos dossiers de transfert avec référence : "${reference}"`;
  }
  
  const message = `Bonjour ${prenom} ${nom},\n\nNous vous contactons concernant ${typeMessage}.\n\nNous aimerions faire un point sur votre dossier. Pourriez-vous nous contacter dès que possible ?\n\nCordialement,\nL'équipe S-Collect`;
  
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
};
